enum BackorderModalVisibilityEnum {
    ALL_USERS = "ALL_USERS",
    INTERNAL_USERS = "INTERNAL_USERS",
    ADMIN_USERS = "ADMIN_USERS",
}

export default BackorderModalVisibilityEnum;
